export const Errors = {
  Empty: "Can't be empty",
  InvalidEmail: 'Enter a valid Email',
};
